import { render } from "./UploadDocuments.vue?vue&type=template&id=6032a1f8&scoped=true&ts=true"
import script from "./UploadDocuments.vue?vue&type=script&lang=ts"
export * from "./UploadDocuments.vue?vue&type=script&lang=ts"

import "./UploadDocuments.vue?vue&type=style&index=0&id=6032a1f8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6032a1f8"]])

export default __exports__